<script setup lang="ts">
import type { PropType } from "vue";

defineProps({
  filters: {
    type: Number,
    default: 0,
  },
  actions: {
    type: Number,
    default: 0,
  },
  headers: {
    type: Array as PropType<number[]>,
    default: [],
  },
  columns: {
    type: Number,
    default: 1,
  },
  cells: {
    type: Number,
    default: 1,
  },
  lane: {
    type: Number,
    default: 1,
  },
  add: {
    type: Boolean,
    default: false,
  },
  hide: {
    type: Boolean,
    default: false,
  },
  stats: {
    type: Boolean,
    default: false,
  },
  toggle: {
    type: Boolean,
    default: false,
  },
  pagination: {
    type: Boolean,
    default: false,
  },
});
</script>
<template>
  <div class="flex flex-col gap-4 p-6 h-full mx-auto">
    <div class="flex justify-between">
      <div class="flex gap-3">
        <div v-if="toggle" class="h-10 w-[190px] skeleton-element"></div>
        <div class="flex gap-2">
          <div v-for="index in filters" :key="index" class="h-10 w-[116px] skeleton-element"></div>
        </div>
      </div>
      <div class="flex gap-2">
        <div v-for="index in actions" :key="index" class="h-10 w-10 skeleton-element"></div>
        <div v-if="add" class="h-10 w-[76px] skeleton-element"></div>
      </div>
    </div>
    <div class="flex flex-col gap-4">
      <div class="flex justify-between gap-1">
        <div class="flex gap-3">
          <div
            v-for="index in headers"
            :key="index"
            v-if="headers.length"
            class="h-[40px] skeleton-element"
            :style="`width: ${index}px`"
          ></div>
        </div>
        <div v-if="hide" class="h-[40px] w-[126px] skeleton-element"></div>
      </div>
      <div v-if="stats" class="flex gap-4 w-full">
        <div class="h-[40px] w-[131px] skeleton-element"></div>
        <div class="h-[40px] w-[255px] skeleton-element"></div>
        <div class="h-[40px] w-[120px] skeleton-element"></div>
      </div>
      <div class="flex flex-col gap-2">
        <div class="flex gap-1 w-full">
          <div v-for="index in columns" :key="index" class="h-[40px] flex-grow skeleton-element"></div>
        </div>
        <div v-for="index in lane" :key="index" class="flex gap-1 w-full">
          <div v-for="index in cells" :key="index" class="h-[40px] flex-grow skeleton-element"></div>
        </div>
        <div v-if="pagination" class="flex gap-2 h-[20px] w-[280px] mt-4">
          <div class="w-[100px] skeleton-element"></div>
          <div v-for="index in 5" :key="index" class="w-[20px] skeleton-element"></div>
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped lang="scss">
.skeleton-element {
  @apply bg-light-grey-color rounded-lg animate-pulse border-2;
  border-color: var(--grey-light);
}
</style>
